export interface LocalizedAnnouncementText {
  description: string;
  button_text: string;
  button2_text?: string;
  button_text2?: string;
}

export interface AnnouncementApiResponse {
  uuid: string;
  is_active: boolean;
  link: string | null;
  priority: string;
  text_pt: LocalizedAnnouncementText;
  text_en: LocalizedAnnouncementText;
  text_es: LocalizedAnnouncementText;
  text_ru: LocalizedAnnouncementText;
  text_de: LocalizedAnnouncementText;
  [key: string]: unknown;
}

export interface AnnouncementViewModel {
  uuid: string;
  description: string;
  priority: string;
  button_text: string;
  button2_text: string;
  link: string;
}

export function getLocalizedAnnouncementText(
  notification: AnnouncementApiResponse,
  language: string
): LocalizedAnnouncementText {
  const lang = language.split("-")[0];
  const languageKey = `text_${lang}`;
  const nested = notification[languageKey] as
    | LocalizedAnnouncementText
    | undefined;

  return {
    description:
      nested?.description ??
      (notification[`description_${lang}`] as string | undefined) ??
      "",
    button_text:
      nested?.button_text ??
      (notification[`button_text_${lang}`] as string | undefined) ??
      "",
    button2_text:
      nested?.button2_text ??
      nested?.button_text2 ??
      (notification[`button2_text_${lang}`] as string | undefined) ??
      (notification[`button_text2_${lang}`] as string | undefined) ??
      "",
  };
}
